<template>
  <b-card class="connection-counter stats-block" v-if="value">
    <b-row>
      <b-col col lg="9">
        <span class="header secondary-color"><b>Total connections uploaded</b>  by employees</span>  </b-col>
        <b-col col lg="3">
          <b-row>
            <b-col col lg="7">
              <div class="round-icon bg-primary-a2 text-primary"><font-awesome-icon icon="user"/></div>
            </b-col>
            <b-col col lg="5">
              <font-awesome-icon icon="caret-down" @click="expand()" :class="{rotated: rotated}" class="primary-color" v-if="expandable"/>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
        <b-row>
          <b-col col lg="9" class="value">{{value}}</b-col>
        </b-row>
        <b-row>
          <b-col col lg="9"><div class="footer secondary-color"  v-if="percentageChange">
            <percentage-change :percent="true" :change="percentageChange" /> uploaded this month
          </div>
        </b-col>
      </b-row>
  </b-card>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import PercentageChange from '@/components/dashboard/percentage-change';

export default {
  name: 'connection-counter',
  props: {
    value: String,
    percentageChange: Number,
    expandable: Boolean,
  },
  computed: {
  },
  data() {
    return {
      percentageChangeAbs: Math.abs(this.percentageChange),
      positive: this.percentageChange >= 0,
      rotated: false,
    };
  },
  methods: {
    expand() {
      this.rotated = !this.rotated;
      this.$emit('expand');
    }
  },
  components: { 'font-awesome-icon': FontAwesomeIcon, PercentageChange }
};
</script>
<style lang="scss">
.connection-counter {
.value {
  font-size: 3.5em;
  font-weight: bold;
}
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/connection-counter.vue